<template>
  <PageLayout
    v-if="showLayout"
    class="tariffs-page"
  >
    <Tariffs />
  </PageLayout>
  <Tariffs v-else />
</template>

<script>
import { mapActions } from 'vuex';
import { default as Tariffs } from '../../views/organizations/tariffs/Index.vue';
import { pages } from '@/entities/current-page';
import { PageLayout } from '@/shared/ui/layouts';

export default {
  created() {
    this.changeActivePage(pages.ORDERS);
  },
  components: { PageLayout, Tariffs },
  computed: {
    showLayout() {
      return this.$route.meta.parent !== 'organizations';
    },
  },
  methods: {
    ...mapActions('currentPageModule', ['changeActivePage']),
  },
};
</script>

<style lang="scss" scoped>
::v-deep .base-modal {
    .content {
        flex-grow: 0 !important;
        padding: 0 !important;
    }
}

::v-deep input {
    border: 1px solid #dde2e5 !important;
    border-radius: 3px !important;

    &:hover {
        border-color: #ffad3d !important;
    }
}

::v-deep .multiselect__input {
    border: none !important;
}
</style>
